export const FETCH_PERMISSION_LIST = "FETCH_PERMISSION_LIST";
export const CREATE_PERMISSION = "CREATE_PERMISSION";
export const UPDATE_PERMISSION = "UPDATE_PERMISSION";
